import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './styles/global.css';
import App from './App';
import { register } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

register();